import genActTypes from "../core/types";

const types = genActTypes("postViews");

export default types;
